import React from 'react';

export default function Dashboard() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h1>Dashboard</h1>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/components/Dashboard.jsx